import React from 'react';
import './mainTitle.css';

const MainTitle = ({ heading, textAlign }) => {
  return (
    <>
      <h1 className="mainTitle" style={{ textAlign: textAlign }}>
        {heading}
      </h1>
    </>
  );
}

export default MainTitle;
